import { useState, useEffect, useRef } from "react";
import ChatList from "./ChatList";
import { SidebarTop } from "./SidebarButtons";
import "../../styles/components/sidebar/sidebar.css";

/**
 * Component contenidor principal de la barra lateral (Sidebar).
 * Inclou el botó de "Nou xat", el cercador i la llista de l'historial de converses.
 * S'encarrega d'ordenar la llista posant els preferits a dalt de tot.
 */
export default function Sidebar({
  chats, activeChatId,
  onNewChat, onSelect,
  onConfirmDeleteRequest, onRenameRequest, onStarChat,
  onSearchOpen,
  deletingId, flashTitleId,
  isOpen, onClose,
  isDesktopCollapsed,
  onToggleSidebar,
  sidebarRef,
}) {
  const [openMenuId, setOpenMenuId] = useState(null);
  const [favFadingId, setFavFadingId] = useState(null);
  const favourites = new Set(chats.filter(c => c.starred).map(c => c.id));

  const toggleFavourite = (id) => {
    setFavFadingId(id);
    setTimeout(() => {
      onStarChat(id);
      setFavFadingId(null);
    }, 200);
  };

  useEffect(() => {
    if (!openMenuId) return;
    const handler = (e) => { if (!e.target.closest('.chat-menu-dropdown, .chat-menu-btn')) setOpenMenuId(null); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [openMenuId]);


  const sortedChats = [...chats].sort((a, b) => {
    const fa = favourites.has(a.id), fb = favourites.has(b.id);
    if (fa && !fb) return -1;
    if (!fa && fb) return 1;
    return 0;
  });

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside ref={sidebarRef} className={`chat-sidebar${isOpen ? ' open' : ''}${isDesktopCollapsed ? ' desktop-collapsed' : ''}`} >
        <SidebarTop
          onNewChat={() => { onNewChat(); onClose?.(); }}
          onSearchOpen={onSearchOpen}
          onClose={onClose}
          onToggleSidebar={onToggleSidebar}
        />
        <ChatList
          chats={sortedChats}
          activeChatId={activeChatId}
          favourites={favourites}
          deletingId={deletingId}
          favFadingId={favFadingId}
          flashTitleId={flashTitleId}
          openMenuId={openMenuId}
          setOpenMenuId={setOpenMenuId}
          toggleFavourite={toggleFavourite}
          onSelect={(id) => { setOpenMenuId(null); onSelect(id); }}
          onRename={(chat) => onRenameRequest(chat)}
          onConfirmDelete={(id) => onConfirmDeleteRequest(id)}
        />
      </aside>
    </>
  );
}


